import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { NewsTypesEnum } from '../enums/NewsTypesEnum';

export const getNewsData = (state: IRootState, newsType: NewsTypesEnum) => state.news[newsType]?.data;
